import type { AalView } from "../aalV2";
import { useAalListQuery } from "../aalV2";

export type SuspensionsAALTableFilters = {
  view: AalView;
  start_date: string;
  end_date: string;
  page?: number;
  size?: number;
  sort?: string;
  action_type?: string;
  agent_id?: string;
  agent_role_id?: string;
  target_user_id?: string;
  username?: string;
};

export type SuspensionsAALTableItem = {
  event_id: string;
  event_sort_key: string;
  created_at: string;
  action_type: string;
  reason: string;
  agent_id: string;
  agent_email: string;
  agent_role_id: string;
  target_user_id: string;
  target_username: string;
};

export const useGetAALSuspensionsTable = (
  filters: SuspensionsAALTableFilters,
) => {
  const {
    view,
    start_date,
    end_date,
    page,
    size,
    sort,
    action_type,
    agent_id,
    agent_role_id,
    target_user_id,
    username,
  } = filters;

  return useAalListQuery<SuspensionsAALTableItem>("suspensions", view, {
    start_date,
    end_date,
    page,
    size,
    sort,
    filters: {
      action_type,
      agent_id,
      agent_role_id,
      target_user_id,
      username,
    },
  });
};
